export default __webpack_public_path__ + "static/media/join-group.07c45d2e.svg";